import React from 'react';
import { Button, Badge } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import useCartStore from '../DataRepo/CartStore';
import { getUserDetails } from '../Auth/AuthUtil';

const MedicineCard = ({ medicine }) => {
    const navigate = useNavigate();
    const { cartItems, addItem, updateQuantity, decreaseQuantity, removeItem } = useCartStore();
    const userDetails = getUserDetails();

    const existingItem = cartItems?.find(cartItem => cartItem?.id === medicine.id);

    const handleAddToCart = (event) => {
        event.stopPropagation();
        if (medicine.onsale && !existingItem) {
            const product = {
                id: medicine.id,
                productName: medicine.medicine,
                quantity: 1,
                price: parseInt(medicine.price),
                desc: medicine.desc,
                companyid: medicine.company_id,
                deliverycharges: medicine.deliverycharges,
                src: medicine.imgurl,
                actualQty: medicine.qty,
                sku: medicine.sku,
                company: medicine.company,
            };
            addItem(product, userDetails?.UID);
        }
    };

    const handleIncreaseQuantity = (event) => {
        event.stopPropagation();
        updateQuantity(medicine.id, userDetails?.UID);
    };

    const handleDecreaseQuantity = (event) => {
        event.stopPropagation();
        if (existingItem.quantity <= 1) {
            removeItem(medicine.id);
        } else {
            decreaseQuantity(medicine.id, userDetails?.UID);
        }
    };

    return (
        <div
            className='Supplement-medicine-card'
            onClick={() => medicine.id && navigate(`/Product?id=${medicine.id}`)}
        >
            <div className='flex flex-row gap-10'>
                <div className='Supplement-medicine-card-image'>
                    <img
                        src={medicine.id ? medicine.imgurl : "https://aiwellassets.s3.ap-south-1.amazonaws.com/Product+place+holder.png"}
                        alt="Medicine"
                    />
                </div>
                <div className='Supplement-medicine-card-info'>
                    <p>{medicine.medicine}</p>
                    <div>
                        <p><span>Dose</span>: {medicine.dose}</p>
                        <p><span>Order Quantity</span>: {medicine.quantity}</p>
                        <p><span>Duration</span>: {medicine.duration}</p>
                        {medicine.timing && <p><span>Timings</span>: {medicine.timing}</p>}
                        <p><span>Instruction</span>: {medicine.instruction}</p>
                    </div>
                    <div className='w-100'>
                        <Button
                            style={{
                                width: '15rem',
                                display: "block",
                                textTransform: 'none',
                                backgroundColor: medicine.onsale ? '#75623F' : '#D9d9d9',
                                color: medicine.onsale ? 'white' : "#A5A39D",
                                border: 'none',
                                boxSizing: 'border-box',
                                borderRadius: "5px",
                                fontFamily: "'Poppins', sans-serif",
                                fontWeight: 500,
                            }}
                            onClick={handleAddToCart}
                            disabled={!medicine.onsale}
                        >
                            <div className="addtobagctn w-100">
                                {medicine.onsale ? (
                                    existingItem ? (
                                        <div style={{ display: "flex", alignItems: "center", width: "100%", justifyContent: "space-evenly" }}>
                                            <RemoveIcon style={{ cursor: "pointer" }} fontSize='small' onClick={handleDecreaseQuantity} />
                                            <span className="!text-[#fdfdfd]">{existingItem.quantity}</span>
                                            <AddIcon style={{ cursor: "pointer" }} fontSize='small' onClick={handleIncreaseQuantity} />
                                        </div>
                                    ) : (
                                        <p>Add to Bag</p>
                                    )
                                ) : (
                                    <p>Coming Soon</p>
                                )}
                            </div>
                        </Button>
                    </div>
                </div>
            </div>
            {medicine.id === '' && <p style={{ fontSize: "8px" }}>This product is not available on our platform.</p>}
        </div>
    );
};

export default MedicineCard;